<template>
  <v-container fluid>
    <material-card icon="mdi-clipboard-text" inline title="Upload Homework">
      <v-container v-if="homework!==''">
        <v-row key="1">
          <v-col cols="6" md="6" sm="6">
            <p>
              Class: {{homework.studentClass.name}} <br>
              Section: {{homework.studentSection.name}} <br>
              {{homework.date}}
            </p>
          </v-col>
          <v-col cols="6" md="6" sm="6">
            <div id="status"
              :class="getColor(homework.studentHomeWorks[0] ? homework.studentHomeWorks[0].approvalStatus : 'Not Submitted')">
              {{ homework.studentHomeWorks[0] ? homework.studentHomeWorks[0].approvalStatus : "Not Submitted" }}
            </div>
          </v-col>
        </v-row>
        <h4 class="mt-3 upload-title">Description</h4>
        <div class="homework-description" v-html="homework.homeWork">
        </div>
        <div v-if="homework.studentHomeWorks[0]">
          <div v-if="homework.studentHomeWorks[0].reviewSummary">
            <h4 class="mt-3 upload-title">Remark</h4>
            <v-divider class=" my-0 " />
            {{homework.studentHomeWorks[0].reviewSummary}}
          </div>
        </div>
        <h4 class="mt-3 upload-title">Teacher uploads</h4>
        <v-divider class=" my-0 " />
        <v-row>
          <v-col class="relative text-truncate" cols="2" md="2"
            v-for="path in homework.studentSubjectDairyDocuments" :key="path.id">
            <a :href="path.signedUrl" target="_blank">
              <v-icon>mdi-file-document-multiple-outline</v-icon> {{fileName(path.urlKey)}}
            </a>
          </v-col>
        </v-row>
        <v-row class="mt-4">
          <v-col>
            <h4 class="text-left upload-title">Student uploads
            </h4>
          </v-col>
          <v-col>
            <h4 class="text-right">
              <b-field class="file is-primary left-auto">
                <b-upload accept=".pdf,.doc,.docx,.png,.jpeg,.jpg,.ppt,.pptx" id="upload-zone"
                  v-model="dropFile" multiple class="file-label" @input="onFilechange()">
                  <span class="file-cta">
                    <b-icon class="file-icon" icon="upload"></b-icon>
                    <span class="file-label">Click to upload</span>
                  </span>
                </b-upload>
              </b-field>
            </h4>
          </v-col>
        </v-row>

        <v-divider class=" my-0 " />
        <v-row v-if="homework.studentHomeWorks[0]">
          <v-col class="text-truncate relative" cols="2" md="2"
            v-for="path in homework.studentHomeWorks[0].studentHomeWorkDocumentMaps" :key="path.id">
            <a :href="path.signedUrl" target="_blank">
              <v-icon>mdi-file-document-multiple-outline</v-icon>
              <span>{{fileName(path.urlKey)}}</span>
            </a>
            <!-- <v-btn class="close-icon" x-small @click="deleteDocument(path.id)"> -->
            <v-icon class="close-icon" @click="deleteDocument(path.id)">mdi-close-box-outline
            </v-icon>
            <!-- </v-btn> -->
          </v-col>

        </v-row>
        <v-divider class=" my-0 " />
        <h3 v-if="dropFile[0]">Current uploaded files</h3>
        <v-row>

          <v-col v-for="(path, index) in dropFile" :key="index" class="text-truncate relative"
            cols="2" md="2">
            <a>
              <v-icon>mdi-file-document-multiple-outline</v-icon>
              <span>{{path.name}}</span>
            </a>
            <!-- <v-btn class="close-icon" x-small @click="deleteDocument(path.id)"> -->
            <v-icon class="close-icon" @click="deleteFromFileBuffer(index)">
              mdi-close-box-outline
            </v-icon>
            <!-- </v-btn> -->
          </v-col>

        </v-row>
      </v-container>
      <v-card-subtitle v-if="homework===''" class="d-flex justify-center">No Data Available
      </v-card-subtitle>
      <v-col>
        <div class="text-right">
          <v-btn color="success" @click="saveHomework" class="px-2 ml-1 ma-1" min-width="0">
            <span class="ml-1">save</span>
          </v-btn>
        </div>
      </v-col>
    </material-card>
    <!-- Loader Start -->
    <loading-icon :value="isLoading" />
    <!-- Loader End -->
  </v-container>
</template>
<script>
import { mapGetters } from 'vuex'
import MaterialCard from '@/components/template/MaterialCard'
import constants from '@/utils/constants'
import moment from 'moment'
import stores from '@/stores'

export default {
  name: 'viewHomework',
  components: { MaterialCard },
  created () {
    this.getHomework()
  },
  data: function () {
    return {
      isLoading: true,
      isUpdate: false,
      homework: '',
      dropFile: [],
      removedFileIndex: [],
      fileBuffer: [],
      allowedFiles: ['pdf', 'pptx', 'docx', 'jpg', 'jpeg', 'png'],
      formData: {
        reviewSummary: '',
        approvalStatus: false
      }
    }
  },
  computed: {
    ...mapGetters({
      franchisee: 'getFranchisee',
      academicYear: 'getAcademicYear'
    })
  },
  watch: {},
  methods: {
    getHomework: async function () {
      try {
        this.homework = ''
        this.isLoading = true
        const { data } = await http.get(`${constants.API_URL}/api/communication/getstudenthomeworkDetails`, {
          params: { subjectDairyID: this.$route.params.id, studentID: stores.user.me.userStudentMap.studentAdmission.id }
        })
        this.homework = data
        if (this.homework.studentHomeWorks[0]) {
          this.isUpdate = !!this.homework.studentHomeWorks[0].id
        }
        this.homework.date = moment(this.homework.date).format('LL')
        console.log(this.homework)
        this.isLoading = false
      } catch (e) {
        this.isLoading = false
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.$buefy.toast.open({
          message: errorMessage,
          type: 'is-danger',
          duration: 4000
        })
      }
    },
    fileName (file) {
      return file.split('/')[file.split('/').length - 1]
    },
    getColor (status) {
      if (status === 'Reviewed') return 'v-green font-weight-bold'
      else if (status === 'Not Reviewed') return 'v-error font-weight-bold'
      else if (status === 'Not Submitted') return 'v-warning font-weight-bold'
      else return 'v-secondary '
    },
    onFilechange () {
      let r = this.dropFile.filter((a, i) => {
        return this.allowedFiles.includes(a.name.split('.').pop())
      })
      this.dropFile = r
    },
    deleteFromFileBuffer (index) {
      this.$buefy.dialog.confirm({
        type: 'is-danger',
        title: 'Alert',
        hasIcon: true,
        message: 'Are you sure to delete the file ?',
        onConfirm: () => this.dropFile.splice(index, 1)
      })
    },
    filterFiles (arr) {
      return arr.filter((item, index) => {
        this.removedFileIndex.forEach((flagIndex) => {
          if (flagIndex === index) {
            return false
          }
        })
        return true
      })
    },
    async saveHomework () {
      try {
        let formData = new FormData()
        for (let i = 0; i < this.dropFile.length; i++) {
          formData.append('file', this.dropFile[i])
        }

        if (this.isUpdate === true) {
          await http.post(`${constants.API_URL}/api/communication/updatestudenthomework/${this.homework.studentHomeWorks[0].id}`, formData)
        } else {
          formData.append('subjectDairyID', this.$route.params.id)
          formData.append('studentID', stores.user.me.userStudentMap.studentAdmission.id)
          await http.post(`${constants.API_URL}/api/communication/createstudenthomework`, formData)
        }
        // Redirecting the user back to the list view after success response
        this.$buefy.dialog.confirm({
          type: 'is-success',
          title: 'Success',
          hasIcon: true,
          message: 'Homework uploaded successfully',
          onConfirm: () => this.$router.push({ name: 'uploadHomework' }),
          canCancel: ['x']
        })
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('error in fetching data : ', errorMessage)
        return this.$buefy.dialog.alert({
          type: 'is-danger',
          title: 'Failed to upload the homework',
          message: errorMessage,
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',
          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    },
    async deleteDocument (id) {
      let that = this
      this.$buefy.dialog.confirm({
        message: `Do you want to delete the image ? `,
        type: 'is-danger',
        hasIcon: true,
        onConfirm: async function () {
          try {
            await http.get(`${constants.API_URL}/api/communication/studenthomework/status/${id}`)
            that.homework = ''
            that.getHomework()
          } catch (error) {
            console.log(error)
          }
        }
      })
    }
  }
}
</script>
<style scoped>
#status {
  text-align: right;
}
.homework-description {
  border: solid rgb(223 179 196) 1px;
}
.left-auto {
  margin-left: 50%;
}
.relative {
  position: relative;
}
.close-icon {
  position: absolute;
  right: 0;
  top: 0;
}
.upload-title {
  font-weight: 600;
}
</style>
